import React, { useEffect, useState } from 'react';
import '../assets/css/intro.css'
import { Button } from '@material-ui/core';
import useDataStore from '../store/dataStore';
import defaultBanner from '../assets/homepage/doctor.png';

const IntroComponent = (props) => {

    const [banner, setBanner] = useState(false)
    const data = useDataStore((state) => state.data);

    useEffect(() => {
        const elem = document.querySelector(':root');
        const bannerUrl = data.banner || defaultBanner;
        if (data.banner ) setBanner(true);
        elem.style.setProperty('--bannerUrl', `url(${bannerUrl})`);
    })


    const custom = (event) => {
        console.log("Branch event");
        props.handleChange(event);
    };

    return (

        (!banner)? 
        (<div className='no-banner'>
            <div className='intro-text'> Welcome to MediBuddy Gold Pro! </div>
            <div className='btn-container'>
                <Button className='ds' variant="contained" onClick={() => custom()}>
                    Buy Now
                </Button>
            </div>
        </div>): (<div className='banner'></div>)

    );

}
export default IntroComponent;
